<template>


    <div class="footer-new">
        
        <div class="footer-new-top">
            <div class="w w1200">
                <div class="service-list">
                    <div class="service-item">
                        <i class="f-icon f-icon-qi"></i>
                        <span>物流保障</span>
                    </div>
                    <div class="service-item">
                        <i class="f-icon f-icon-zheng"></i>
                        <span>正品保障</span>
                    </div>
                    <div class="service-item">
                        <i class="f-icon f-icon-hao"></i>
                        <span>好评如潮</span>
                    </div>
                    <div class="service-item">
                        <i class="f-icon f-icon-shan"></i>
                        <span>闪电发货</span>
                    </div>
                    <div class="service-item">
                        <i class="f-icon f-icon-quan"></i>
                        <span>权威荣誉</span>
                    </div>
                </div>
                <div class="contact">
                    <div class="contact-item contact-item-first"><i class="f-icon f-icon-tel"></i><span>19130659157</span></div>
                </div>
            </div>
        </div>
        <div class="footer-new-con">
            <div class="fnc-warp">
                <div class="help-list">
                    <div class="help-item" v-for="v in column_list" :key="v.id">
                        <h3>{{ v.name }} </h3>
                        <ul v-if="v.content">
                        <li  v-for="secMenu in v.content" :key="secMenu.id"><a :href="'/article/info/'+secMenu.id" target="_blank">{{ secMenu.newsTitle }}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="qr-code">
                    <div class="qr-item qr-item-first">
                        <div class="code_img"><img src="/pc/ecjia_qrcode.png"></div>
                        <div class="code_txt">微信订阅号</div>
                    </div>
                    <div class="qr-item">
                        <div class="code_img"><img src="/pc/ectouch_qrcode.png"></div>
                        <div class="code_txt">微信服务号</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-new-bot">
            <div class="w w1200">
                
                
                <p><span>版权所有 四川省科欣医药贸易有限公司 Copyright 2004-2009 备案号：<a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备13013789号</a></span></p>
                <p><span>地址:四川省成都市金牛区金丰路6号新区10幢 电话：19130659157</span></p>                     
                <p><span>.本公司网站不得发布麻醉药品、精神药品、医疗用毒性药品、放射性药品、戒毒药品和医疗机构制剂的产品信息。</span></p> 
                <p><span><a href="/pc/药品经营许可证20191226.jpg" target="_blank">《药品经营许可证》证书编号：川AA0280459</a>&nbsp;|&nbsp;<a href="/pc/互联网药品信息服务资格证书正本20230109.jpg" target="_blank">《互联网药品信息服务资格证书》证书编号：（川）-非经营性-2023-0004</a>&nbsp;|&nbsp;<a href="/pc/20220311医疗器械许可证.jpg" target="_blank">《医疗器械许可证》：川蓉食药监械经营许 20170270号</a>&nbsp;|&nbsp;<a href="/pc/20220322二类医疗器械备案凭证.jpg" target="_blank">《第二类医疗器械经营备案凭证》：川蓉食药监械经营备20151375号</a>&nbsp;|&nbsp;<a href="/pc/20200628营业执照正本.jpg" target="_blank">《营业执照》：91510000795820300F</a></span></p> 
                <p><span>免责声明：以上信息由四川省科欣医药贸易有限公司专业团队收集整理，仅供参考之用。</span></p> 

                <p class="Guarantee">
                    <a href="https://www.cdnet110.com/" rel="nofollow" target="_blank"><img alt="药品批发" src="/pc/Guarantee_1.jpg" /></a>
                    <a href="#" rel="nofollow" target="_blank"><img alt="药品批发" src="/pc/Guarantee_2.jpg" /></a>
                    <a href="https://www.12321.cn/" rel="nofollow" target="_blank"><img alt="药品批发" src="/pc/Guarantee_3.jpg" /></a>
                    <a href="https://www.isc.org.cn/" rel="nofollow" target="_blank"><img alt="药品批发" src="/pc/Guarantee_4.jpg" /></a>
                    <a href="#" target="_blank" style="z-index:9999; width:50px;"><img alt="药品批发" src="/pc/cdgs.jpg" /></a>
                </p>

                <p class="copyright_auth"><a href="/user/bug" target="_blank">bug提交</a></p>
                
            </div>
        </div>

    </div>

</template>

<script>
// import ShopIndexAdv from "@/components/home/public/shop_index_adv.vue"
export default {
    components: {
        // ShopIndexAdv,
    },
    data() {
      return {
          //广告位
          showAdver:[],
          column_list:[],
      };
    },
    watch: {},
    computed: {},
    methods: {
        // get_foot_info:function(){
        //     this.$get(this.$api.homeGetFootInfo).then(res=>{
        //         this.adv = res.data.adv.adv[0];
        //         this.info = res.data.info;
        //     });
        // },
        //广告位
        // get_showAdver:function(){
        //     this.$get(this.$api.showAdver +5).then(res=>{
        //         if(res.code == 200){
        //             this.showAdver = res.data.list;
        //         }
                
        //     });
        // },


        // 底部帮助
        get_column_list:function(){
            this.$get(this.$api.getHelpCenter,{platId:this.$platId}).then(res=>{
                this.column_list = res.data;
            });
        },


    },
    created() {
        // this.get_foot_info();
        //广告位
        // this.get_showAdver();
        this.get_column_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.shop_foot{
    padding-top: 10px;
    text-align: center;
    ul{
        margin:40px auto 0 auto;
        width: 664px;
        border-top: 1px solid #efefef;
        padding-top: 40px;
    }
    ul li{
        float: left;
        margin-right: 40px;
        margin-bottom: 60px;
        font-size: 14px;
        a:hover{
            color:#409EFF;
        }
    }
    ul li:last-child{
        margin-right: 0px;
    }
    .foot_copyright{
        clear: both;
        font-size: 12px;
        line-height: 35px;
        padding-bottom: 20px;
    }
}
.Guarantee{margin:20px 0;}
.Guarantee a img{width:118px; height:48px;}
.Guarantee a{margin:0 5px;}
.footer-new-bot p span a{margin: 0 10px;}
</style>